module.exports = __webpack_public_path__ + "img/gold.d6dfabc6.png";